import type { TicketDetailTimelineEntry } from '@nightshift/ui-types';

/**
 * Events that change what an operator would do next. Everything else on the
 * timeline (waits clearing, pipeline observations, checkpoints, artifacts) is
 * bookkeeping that is true but rarely worth a line, so the Activity tab hides
 * it until "Show all" is pressed.
 */
const KEY_EVENT_TYPES: ReadonlySet<string> = new Set([
  'TicketCreated',
  'TicketStarted',
  'TransitionApplied',
  'TicketWaiting',
  'HumanActionRequested',
  'MergeRequested',
  'MergeCompleted',
  'TicketCancelled',
  'TicketRestored',
  'DeployRequested',
  // A recorded footprint is the estimate the dependency comparison runs on, and it is only
  // ever written for a footprint that landed current -- `apply-footprint.ts` emits no event
  // for one born superseded. Hiding it made a recorded estimate look like it never happened.
  'FootprintRecorded',
  // Who approved the landing, or why the auto-merge policy left it for a person. Both change
  // what a reader does next.
  'PolicyApproved',
  'AutoMergeDeclined',
]);

export function isKeyTimelineEntry(entry: TicketDetailTimelineEntry): boolean {
  switch (entry.kind) {
    case 'human':
      return true;
    case 'attempt':
      return true;
    case 'checkpoint':
      return false;
    case 'event':
      // Unknown event types were never given a title of their own; treat them as noise.
      return entry.eventType != null && KEY_EVENT_TYPES.has(entry.eventType);
    default:
      return false;
  }
}
